import { createContext } from "react";
import type { TimesheetFlowContextValue } from "@/features/timesheetFlow/timesheetFlowTypes";

export const TimesheetFlowContext = createContext<TimesheetFlowContextValue | null>(null);
